module.exports = __webpack_public_path__ + "img/banner.2b1c89e.png";